<template>
  <div v-if="loading">
    <v-flex offset-xs5 pa-5>
      <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
  </div>
  <div v-else>
    <v-toolbar :class="['toolbar-element', { 'presentation-content' : $store.state.miniLateralNav }]" light absolute flat height="100em">
      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-toolbar-title class="toolbar-title toolbar-spacing">
          <div style="display: flex;" v-if="this.$store.state.permissions.canDeletePresentacionesCargaLpf && this.presentacion.cargaLpf">
            <div>{{ presentacion.nombre }}</div>
            <div @click="deletePresentacionCargaLpf" class="delete-container pl-3">
                <v-btn icon color="primary"><v-icon color="6D6D6D">mdi-delete</v-icon></v-btn>
            </div>
          </div>
          <div v-else>{{ presentacion.nombre }}</div>
          <ConfirmationDialog :function-yes="bindingFunction" ref="confirm"
                        text="Los datos cargados no podrán ser recuperados." title="¿Eliminar presentación?"></ConfirmationDialog>
          <p v-if="!isPresentation && presentacion.estadoDisplay!=='En progreso'"
            class="small-text">
            {{descripcion }}
          </p>
          <div>
            <div style="display: flex; align-items: center">
              <div class="small-text">{{ expirationMessage }} </div>
              <div v-if="period" class="small-text pl-5" >Período: {{ period }}</div>
            </div>
          </div>
          <v-card-actions class="small-text body-content" v-if="showSelectTemporada">
            Temporada:
            <v-select v-model="temporada"
                      :items="temporadas"
                      item-text="nombre"
                      item-value="pk"
                      no-data-text="No hay datos disponibles">
            </v-select>
          </v-card-actions>
        </v-toolbar-title>
      </template>
      <div class="description-container toolbar-title" v-if="this.draft || (this.presentacion.estadoDisplay==='En carga' && !this.isSafRole) && !isPresentation">
        <p class="small-text body-content">Descripción:</p>
        <v-text-field
        no-resize
        class="description-text-field"
        maxlength="60"
        variant="solo-filled"
        v-model="descripcion">
      </v-text-field>
      </div>
      <v-spacer></v-spacer>
      <component :is="currentActionButtons"
                 class="action-buttons"
                 :estado-permissions="estadoPermissions"
                 :can-submit="canSubmitActualizacion"
                 :temporada="temporada"
                 :descripcion="descripcion">
      </component>
    </v-toolbar>
    <!--    LateralTreeView-->
    <v-navigation-drawer fixed permanent class="navigator-tree" width="400" v-show="$store.state.miniLateralNav">
      <v-toolbar color="#355487" flat class="white--text">
        <v-list-tile-content>
          <v-list-tile-title class="club-text custom-font-regular" v-if="isSafRole">Club {{ clubName }}</v-list-tile-title>
          <v-list-tile-sub-title class="club-sub-text custom-font-regular">{{ presentacion.nombre }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-spacer></v-spacer>
        <v-btn small light @click="seeHistory" class="history-button blue--text" v-if="!hideHistory">
          <v-icon small color="blue" class="icon-build">history</v-icon>
          <span>Historial</span>
        </v-btn>
      </v-toolbar>
      <v-layout row wrap v-if="!draft">
        <v-flex xs12>
          <v-divider color="lightgrey" class="toolbar-divider"></v-divider>
          <v-card color="#355487" flat class="white--text">
            <v-card-actions class="status-percentage">
              <span v-if="subsanada" class="custom-font-semi-bold status-text">{{ "SUBSANADA" }}</span>
              <span  v-else class="custom-font-semi-bold status-text">{{ presentacion.estadoDisplay.toUpperCase() }}</span>
              <v-spacer></v-spacer>
              <PresentacionProgressCircular :criterios="criterios" :showCorrected="showCorrectedPercentage"></PresentacionProgressCircular>
            </v-card-actions>
          </v-card>
          <v-divider color="lightgrey" class="toolbar-divider"></v-divider>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-divider color="lightgrey" class="toolbar-divider"></v-divider>
      </v-layout>

      <v-card color="#355487" flat>
        <v-card-text>
          <div class="custom-font-regular" v-if="isSafRole && unsettedExpirationCriteria">
            <v-icon small color="orange lighten-1" class="mr-1">error</v-icon>
            <span class="orange--text">{{ expirationAlertMessage }}</span>
          </div>

          <v-spacer></v-spacer>
          <v-layout row wrap align-center>
            <v-flex xs8 sm8 md8>
              <v-text-field v-model="search" label="Buscar Criterio..." dark flat class="search-bar pa-0 dense-text-field" solo-inverted
                            hide-details clearable clear-icon="mdi-close-circle-outline" height="35"></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-btn-toggle v-model="toggle_multiple" depressed multiple class="transparent">
                <v-btn flat @click="fireUpdate">
                  <v-tooltip bottom>
                    <v-icon small color="green lighten-1" slot="activator">check_circle</v-icon>
                    <span>Revisado ok</span>
                  </v-tooltip>
                </v-btn>
                <v-btn flat @click="fireUpdate">
                  <v-tooltip bottom>
                    <v-icon small color="red lighten-1" slot="activator">error</v-icon>
                    <span>Revisado incompleto</span>
                  </v-tooltip>
                </v-btn>
                <v-btn flat @click="fireUpdate">
                  <v-tooltip bottom>
                    <v-icon small color="yellow darken-3" slot="activator">pause_circle_filled</v-icon>
                    <span>A Revisar</span>
                  </v-tooltip>
                </v-btn>
                <v-btn flat @click="fireUpdate">
                  <v-tooltip bottom>
                    <v-icon  small color="yellow darken-3" slot="activator">edit</v-icon>
                    <span>No presentado</span>
                  </v-tooltip>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <v-treeview
                  :key="componentKey"
                  :items="items"
                  :search="search"
                  :filter="filter"
                  item-key="pk"
                  item-text="title"
                  :open.sync="open"
                  :active.sync="active"
                  :open-all="true"
                  open-on-click
                  transition
                  activatable
                  active-class="info--text"
                  class="custom-font-regular white--text white-icon">
            <template slot="prepend" slot-scope="props">
              <StatusIcon :status="props.item.estadoDisplay"></StatusIcon>
              <ExpirationIcon :criterion="props.item"></ExpirationIcon>
            </template>
          </v-treeview>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
    <!--    LateralTreeView-->

    <v-flex :class="{ 'presentation-content':$store.state.miniLateralNav }" mt-5 pt-2>
      <CriterioDetailTreeView :estados-requerimientos="estadosRequerimiento" :criterio="criterio"
                              @updateRequerimiento="updateAfterRequest"
                              @updateCriterionExpiration="updateCriterionExpiration"
                              :draft="draft" :is-ficha="draft">
      </CriterioDetailTreeView>
    </v-flex>
    <HistoryDialog ref="history" :history="history" :subsanada="wasSubsanada" v-if="!hideHistory"></HistoryDialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { requiredIf } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import store from '../../../app/store'
import StatusIcon from '../components/StatusIcon'
import ExpirationIcon from '../components/ExpirationIcon'
import HistoryDialog from '../components/HistoryDialog'
import CriterioDetailTreeView from '../components/CriterioDetailTreeView'
import PresentacionProgressCircular from '../components/PresentacionProgressCircular'
import PresentacionActionButtonsSaf from '../components/PresentacionActionButtonsSaf'
import PresentacionActionButtonsClub from '../components/PresentacionActionButtonsClub'
import PresentacionUpdateActionButtonsSaf from '../../presentacion_update/components/PresentacionUpdateActionButtonsSaf'
import PresentacionUpdateActionButtonsClub from '../../presentacion_update/components/PresentacionUpdateActionButtonsClub'
import PresentacionDraftActionButtonsClub from '../../presentacion_draft/components/PresentacionDraftActionButtonsClub'
import Constants from '../../../common/constants'
import PresentacionActionButtonsCargaLpf from '../components/PresentacionActionButtonsCargaLpf'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'

const NO_PRESENTADO = Constants.NO_PRESENTADO
const REVISADO_INCOMPLETO = Constants.REVISADO_INCOMPLETO
const REVISADO_OK = Constants.REVISADO_OK
const A_REVISAR = Constants.A_REVISAR

export default {
  mixins: [validationMixin],

  props: {
    path: {
      type: String,
      default: 'frontend/presentacion/'
    },
    actionButtonsPrefix: {
      type: String,
      default: 'PresentacionActionButtons'
    },
    hideHistory: Boolean,
    draft: Boolean
  },

  components: {
    StatusIcon,
    ExpirationIcon,
    HistoryDialog,
    CriterioDetailTreeView,
    PresentacionProgressCircular,
    PresentacionActionButtonsSaf,
    PresentacionActionButtonsClub,
    PresentacionUpdateActionButtonsSaf,
    PresentacionUpdateActionButtonsClub,
    PresentacionDraftActionButtonsClub,
    PresentacionActionButtonsCargaLpf,
    ConfirmationDialog
  },

  validations () {
    return {
      temporada: { required: requiredIf(() => { return this.showSelectTemporada }) },
      descripcion: { required: requiredIf(() => { return this.hasDescription }) }
    }
  },

  data () {
    return {
      items: [],
      open: [],
      active: [],
      club: {},
      clubName: '',
      criterio: {},
      loading: true,
      history: [],
      subsanada: false,
      presentacion: {},
      estadoPermissions: {},
      estadosRequerimiento: [],
      search: null,
      toggle_multiple: [0, 1, 2, 3],
      filterSelection: [REVISADO_OK, REVISADO_INCOMPLETO, A_REVISAR, NO_PRESENTADO],
      componentKey: 0,
      temporada: null,
      temporadas: [],
      descripcion: '',
      isPresentation: null,
      period: null,
      bindingFunction: null
    }
  },

  computed: {
    ...mapGetters(['isSafRole', 'role']),
    criterios () {
      return this.getCriterios()
    },
    wasSubsanada () {
      const aSubsanar = this.history.find(item => item.estado === 'A subsanar')
      return aSubsanar !== undefined
    },
    filter () {
      return (item, search, textKey) => {
        const found = item[textKey].toLowerCase().indexOf(search.toLowerCase()) > -1

        return found
          ? this.toggle_multiple.some(filterIndex => item.estadoDisplay === this.filterSelection[filterIndex])
          : false
      }
    },
    currentActionButtons () {
      if (this.presentacion.cargaLpf) {
        return this.actionButtonsPrefix + 'CargaLpf'
      }
      return this.actionButtonsPrefix + this.role
    },
    unsettedExpirationCriteria () {
      return this.getCriterios().reduce((total, criterio) => {
        return (this.criterioHasUnsettedExpiration(criterio)) ? total + 1 : total
      }, 0)
    },
    expirationAlertMessage () {
      let letterS = (this.unsettedExpirationCriteria > 1) ? 's' : ''
      return `${this.unsettedExpirationCriteria} criterio${letterS} Revisado ok, pero sin vencimiento asignado`
    },
    expirationMessage () {
      if (!this.presentacion.hasOwnProperty('daysToExpire')) return ''
      if (this.presentacion.cargaLpf) return 'En carga por LPF'
      let daysToExpire = this.presentacion.daysToExpire
      if (daysToExpire <= 0) {
        return `Vencida el ${this.presentacion.fechaVencimiento}`
      }
      let letterS = (daysToExpire === 1) ? '' : 's'
      let letterN = (daysToExpire === 1) ? '' : 'n'
      return `Vence el ${this.presentacion.fechaVencimiento} (resta${letterN} ${daysToExpire} día${letterS} corrido${letterS})`
    },
    showCorrectedPercentage () {
      return this.isSafRole && ![Constants.EN_CARGA, Constants.A_SUBSANAR].includes(this.presentacion.estadoDisplay)
    },
    showSelectTemporada () {
      return this.draft
    },
    canSubmitActualizacion () {
      this.$v.$touch()
      return !this.$v.$invalid
    },
    hasDescription () {
      return this.draft
    }
  },

  methods: {
    fireUpdate () {
      this.search = Object.assign('', this.search)
    },
    getCriterios () {
      return this.items.flatMap(area => area.children.flatMap(subarea => subarea.children))
    },
    getCriterio (id) {
      return this.getCriterios().find(criterion => criterion.pk === id)
    },
    criterioHasUnsettedExpiration (criterio) {
      let hasStatusForApprove = (criterio.estadoDisplay === REVISADO_OK || criterio.estadoDisplay === NO_PRESENTADO)
      return criterio.expire && !criterio.expiration.date && hasStatusForApprove
    },
    fetchCriterio () {
      this.criterio = this.getCriterio(this.active[0])
    },
    addProperty (object, newProp, copyObject, copyProp) {
      Object.defineProperty(object, newProp, Object.getOwnPropertyDescriptor(copyObject, copyProp))
    },
    renameProperty (object, oldProp, newProp) {
      this.addProperty(object, newProp, object, oldProp)
      delete object[oldProp]
    },
    formatPresentationForTreeView () {
      for (let area of this.items) {
        this.renameProperty(area, 'subareas', 'children')
        for (let subarea of area.children) {
          this.renameProperty(subarea, 'criterios', 'children')
          for (let criterio of subarea.children) {
            this.addProperty(criterio, 'title', criterio, 'nombre')
          }
        }
      }
    },
    initOpenTabs () {
      let firstArea = this.items[0]
      let firstSubarea = firstArea.children[0]
      this.open[0] = firstArea.pk
      this.open[1] = firstSubarea.pk
      this.active[0] = firstSubarea.children[0].pk
    },
    updateAfterRequest (response) {
      (this.draft) ? this.updateAfterRequestDraft(response) : this.updateAfterRequestPresentation(response.data)
    },
    updateAfterRequestPresentation (updatedRequerimiento) {
      let criterios = this.getCriterios()
      for (let criterio of criterios) {
        for (let index in criterio.requerimientos) {
          const requerimiento = criterio.requerimientos[index]
          if (requerimiento.pk === updatedRequerimiento.pk) {
            this.$set(criterio.requerimientos, index, updatedRequerimiento)
            this.$set(criterio, 'estadoDisplay', updatedRequerimiento.criterio.estado)
            this.estadoPermissions = updatedRequerimiento.estadoPermissions
            break
          }
        }
      }
    },
    updateAfterRequestDraft (response) {
      if (response.status === 204) {
        this.$store.commit('setDraft', null)
        this.$router.push({ name: 'actualizaciones' })
      } else {
        this.setDraft(response)
        this.fetchCriterio()
      }
    },
    setDraft (response) {
      this.presentacion = response.data
      this.items = response.data.draft
      this.formatPresentationForTreeView()
      this.initOpenTabs()
    },
    updateCriterionExpiration (data) {
      this.estadoPermissions = data.presentationStatus
      this.getCriterio(data.pk).expiration = data.expiration
    },
    seeHistory () {
      this.$refs.history.showDialog()
    },
    fetchPresentacion () {
      this.axios
        .get(`${this.path}${this.$route.params.id}`)
        .then(response => {
          this.presentacion = response.data
          this.club = response.data.club
          this.clubName = response.data.club.nombre
          this.items = response.data.presentacion
          this.estadoPermissions = response.data.estadoPermissions
          this.estadosRequerimiento = response.data.estados
          this.history = response.data.history
          this.subsanada = response.data.subsanada
          this.formatPresentationForTreeView()
          this.initOpenTabs()
          this.loading = false
          this.descripcion = response.data.descripcion
          this.isPresentation = (this.presentacion.fechaVencimiento != null)
          this.period = response.data.period
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchDraft () {
      this.axios
        .get('draft')
        .then(response => {
          this.setDraft(response)
          this.fetchSeasons()
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchSeasons () {
      this.axios
        .get('seasons')
        .then(response => {
          this.temporadas = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    deletePresentacionCargaLpf () {
      this.bindingFunction = () => {
        this.axios
          .delete(`presentaciones-cargalpf/eliminar/${this.$route.params.id}`)
          .then(response => {
            this.loading = false
            this.$router.go(-1)
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      }
      this.$refs.confirm.openDialog()
    }
  },

  mounted () {
    (this.draft) ? this.fetchDraft() : this.fetchPresentacion()
  },

  watch: {
    'active' () {
      if (this.active.length) {
        this.fetchCriterio()
      } else {
        this.active[0] = this.criterio.pk
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    store.commit('hideLateralNav')
    next()
  }
}
</script>

<style scoped>
  .navigator-tree {
    margin-left: 5.7em;
    background-color: #355487;
    margin-top: 4.6em !important;
    padding-top: 1em;
    padding-bottom: 6em;
  }
  .percentage-charged {
    margin-left: 1em;
    color: lightgrey;
  }
  .toolbar-divider {
    margin: 0 1em 0 1em;
  }
  .status-percentage {
    padding: 0.5em 1.8em 0.5em 1.8em;
  }
  .club-text {
    font-weight: bold;
    font-size: 1.4em;
  }
  .club-sub-text {
    font-size: 1em;
  }
  .presentation-content {
    padding-left: 27.5em !important;
  }
  .custom-font-regular {
    font-family: SourceSansProRegular, sans-serif;
  }
  .custom-font-semi-bold {
    font-family: SourceSansProSemiBold, sans-serif;
  }
  .toolbar-spacing {
    margin-left: 0.6em;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .small-text {
    font-size: 0.5em;
    padding-left: 0.1em;
  }
  .history-button {
    font-size: 0.9em;
  }
  .icon-build {
    margin-right: 0.3em;
  }
  .v-progress-circular {
    margin-left: 5px;
    height: 30px !important;
  }
  .v-btn-toggle--selected {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .body-content {
    padding: 1px;
  }
  .description-container{
    display: flex;
    align-items: center;
    margin-top: 46px;
    margin-left: 1em;
  }
  .description-container > p{
    margin-bottom: 0;
    font-size: 15.4px;
  }
  .description-subtitle{
   font-size: 16px;
  }
  .description-text-field{
    margin-left: 5px;
    width: 300px;
  }
</style>
